import { useEffect, useState } from 'react'
import type { CardData } from './IntakeCard'
import { cardPdfFile, shareCardPdf } from '../lib/cardPdf'

/**
 * The intake card as an exact 5x7 PDF, handed to the iPad's share sheet, where Print prints it at actual size.
 * (A printed web page gets Safari's margins and URL / date footer and shrinks; a PDF does not.) The PDF is built
 * as soon as the card is known so the tap can open the share sheet straight away (it has to happen inside the tap).
 */
export function usePrintCard(card: CardData | null) {
  const [file, setFile] = useState<File | null>(null)
  const [err, setErr] = useState('')
  const key = card ? JSON.stringify(card) : ''
  useEffect(() => {
    if (!card) return
    let live = true
    setFile(null); setErr('')
    cardPdfFile(card).then((f) => { if (live) setFile(f) }).catch((e) => { if (live) setErr(String(e?.message ?? e)) })
    return () => { live = false }
  }, [key])  // eslint-disable-line react-hooks/exhaustive-deps
  const print = () => { if (file) void shareCardPdf(file) }
  return { ready: !!file, err, print }
}

export function PrintCardButton({ card, className = 'cta cta--center', label = 'Print card' }: { card: CardData; className?: string; label?: string }) {
  const { ready, err, print } = usePrintCard(card)
  return (
    <button type="button" className={className} disabled={!ready} onClick={print} title={err || undefined}>
      {err ? 'Card could not be made' : ready ? label : 'Making the card…'}
    </button>
  )
}
